import React from "react"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { SubscriptionType } from "sharedTypes"

const WalletPassUpgradeAlert = () => (
  <UpgradeAlert
    text="This feature requires an Enterprise Subscription."
    defaultSelectedPlan={SubscriptionType.Enterprise}
    continueOnTheCurrentScreen
  />
)

export default WalletPassUpgradeAlert
